import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';
import { Refinery } from '../../../_models/_unit-operations/refinery';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { RefineryCellConfig, RefinerySheetRows } from '../cell-config/refinery-cell-config';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { RefineryFlexSheetMapper } from '../mappers/refinery-flex-sheet-mapper';

export class RefineryFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: Refinery, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(RefinerySheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = RefineryCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new RefineryFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
